module.exports = __webpack_public_path__ + "static/media/Pritesh.31d1273a.jpeg";